import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'

export const GeneralToastContaner = styled(ToastContainer)``

export const InfoToastContainer = styled(GeneralToastContaner)`
    &.toast-container {
        position: relative;
        margin-bottom: 1px;
    }
    
    .info-toast {
        background-color: var(--cyan-complement-color);
        color: var(--fai-dark-color);
        padding: 15px 20px;
    }
    
    .Toastify__close-button {
        border: none;
        background: transparent;
        position: absolute;
        top: 5px;
        right: 5px;
    }
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Global/Toast.js